import {
    formatValueToInputString,
    parseInputString
} from '../ItemsListTextareaEditor/itemsListTextareaEditor';

export const formatBannedDomainsEditorValue = (items: string[]): string => {
    return formatValueToInputString(items, '\n');
};

export const parseBannedDomainsEditorValue = (inputValue: string): string[] => {
    return parseInputString(inputValue, '[\\n,]')
        .map(value => value.trim())
        .filter(value => value !== '');
};
